// Shared TTL-liveness check for every `expiresAt`-bearing entry in the assistant-surface-context
// protocol (committed-state accumulator entries, ...). Centralised so every caller makes the same
// clock-skew/format assumptions -- two separate inline copies of `Date.parse(x) > Date.now()` is
// exactly the kind of duplication that drifts silently if either one's edge-case handling ever
// needs to change.
export function isLive(expiresAt: string): boolean {
  return Date.parse(expiresAt) > Date.now()
}

// Every current committed-state producer (search, selected flight itinerary) uses this same 24h
// TTL, decided directly rather than reused from an upstream expiry -- no existing expiry fits: the
// ~20-minute session/quote expiry would make a fact stale almost immediately even with nothing
// changed. One constant, not four independent `Date.now() + ...` literals to keep in sync.
export const COMMITTED_STATE_TTL_MS = 24 * 60 * 60 * 1000

export function buildCommittedStateExpiresAt(): string {
  return new Date(Date.now() + COMMITTED_STATE_TTL_MS).toISOString()
}
